import {AppStatus} from "./App";
import classes from "./ReadyArea.module.css";

type Props = {
    setAppStatus: (appStatus:AppStatus)=>void
}

export const ReadyArea = ({setAppStatus}: Props) => {
    return(
        <>
            <div className={classes.readyArea}>
                <button className={classes.startButton} id="start" onClick={() => setAppStatus("run")}>スタート！</button>
            </div>
        </>
    )
}